import { render, staticRenderFns } from "./BulletPointDescription.vue?vue&type=template&id=0587481e&scoped=true"
import script from "./BulletPointDescription.vue?vue&type=script&lang=js"
export * from "./BulletPointDescription.vue?vue&type=script&lang=js"
import style0 from "./BulletPointDescription.vue?vue&type=style&index=0&id=0587481e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_cy24jmswklxzc46cxvuobxvpsa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587481e",
  null
  
)

export default component.exports